import { useForm } from '@/common/form/FormContext';
import { useMemo } from 'react';

// Each period axis hides the other period's filter (by its filter code), and a hidden filter must not apply either
export const hiddenPeriodFilter = {
  EARNED_PERIOD: { code: 'RBT_PERIOD', field: 'rbtPeriodExpr' },
  RBT_PERIOD: { code: 'EARNED_PERIOD', field: 'earnedPeriodExpr' },
};

// The filter params every Dispute Outcome plugin takes
export const useDispReqParam = (dispCodeCount) => {
  const { formValues } = useForm();
  const hiddenField = hiddenPeriodFilter[formValues.xAxis]?.field;

  return useMemo(
    () => ({
      prodExpr: formValues.prodExpr,
      brandExpr: formValues.brandExpr,
      // Sending nothing when every Dispute Code is selected skips the filter
      dispCodes: formValues.dispCodes?.length >= dispCodeCount ? null : (formValues.dispCodes ?? null),
      vendorExpr: formValues.vendorExpr,
      ctrtExpr: formValues.ctrtExpr,
      rbtPeriodExpr: hiddenField === 'rbtPeriodExpr' ? null : formValues.rbtPeriodExpr,
      earnedPeriodExpr: hiddenField === 'earnedPeriodExpr' ? null : formValues.earnedPeriodExpr,
      stateExpr: formValues.stateExpr,
    }),
    [
      formValues.prodExpr,
      formValues.brandExpr,
      formValues.dispCodes,
      dispCodeCount,
      formValues.vendorExpr,
      formValues.ctrtExpr,
      formValues.rbtPeriodExpr,
      formValues.earnedPeriodExpr,
      formValues.stateExpr,
      hiddenField,
    ],
  );
};
